import React, { useState } from "react";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import {
  Grid,
  Paper,
  Typography,
  Divider,
  TextField,
  Checkbox,
  FormControlLabel,
  Collapse,
  Button,
  Chip,
  makeStyles,
} from "@material-ui/core";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import DoneRoundedIcon from "@material-ui/icons/DoneRounded";
import validator from "validator";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiChip-root": {
      marginRight: theme.spacing(1),
    },
  },
}));

const AddUpdateContacts = ({ onUpdate, contacts }) => {
  const [updateContact, setUpdateContact] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [primary, setPrimary] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);

  const classes = useStyles();

  const isPrimaryExist = (contacts) => {
    const primaryIndex = contacts.findIndex((c) => c.primary === true);

    return primaryIndex > -1;
  };

  const handleCreateContact = () => {
    const contactDetails = {
      contact_first_name: firstName,
      contact_last_name: lastName,
      contact_role: role,
      contact_email: email,
      contact_mobile: mobile,
      is_primary: contacts.length === 0 ? true : primary,
    };
    if (!updateContact) onUpdate("contact", contactDetails);
    else {
      //update contact:
      onUpdate("contact", { ...contactDetails, id: updateContact.id });
    }
    clearForm();
  };

  const handleSelectContactForUpdate = (contact) => {
    //locate the contact from the array of contacts:
    const contactIndex = contacts.findIndex(
      (cont) =>
        cont.contact_email === contact.contact_email &&
        cont.contact_first_name === contact.contact_first_name &&
        cont.contact_last_name &&
        contact.contact_last_name
    );
    if (contactIndex > -1) {
      clearForm();
      setUpdateContact(contacts[contactIndex]);
      //update form:
      const {
        contact_first_name,
        contact_last_name,
        contact_role,
        contact_email,
        contact_mobile,
        is_primary,
      } = contacts[contactIndex];
      setFirstName(contact_first_name);
      setLastName(contact_last_name);
      setRole(contact_role);
      setEmail(contact_email);
      setMobile(contact_mobile);
      setPrimary(is_primary);
    }
  };

  const handleFormChange = (type, value) => {
    switch (type) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "role":
        setRole(value);
        break;
      case "email":
        setEmail(value);
        setEmailTouched(value !== "");
        break;
      case "mobile":
        setMobile(value);
        break;
      case "primary":
        setPrimary(value);
        break;
      default:
        break;
    }
  };

  const handleCancel = () => {
    clearForm();
  };

  const handleRemoveContact = (id) => {
    clearForm();
    onUpdate("removeContact", id);
  };

  const formValidation = () => {
    if (firstName === "" || lastName === "") return false;
    if (!validator.isEmail(email)) return false;
    return true;
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setRole("");
    setEmail("");
    setMobile("");
    setPrimary(false);
    setUpdateContact(null);
    setEmailTouched(false);
  };
  return (
    <Paper className={classes.root}>
      <Typography variant={"subtitle1"} color="textPrimary">
        Company Contacts
      </Typography>
      <Divider />
      <Collapse in={contacts && contacts.length > 0}>
        {contacts &&
          contacts.map((contact) => (
            <Chip
              key={`${contact.contact_first_name} ${contact.contact_last_name}`}
              clickable
              onDelete={() => handleRemoveContact(contact.id)}
              label={`${contact.contact_first_name} ${contact.contact_last_name}`}
              icon={contact.is_primary ? <StarBorderRoundedIcon /> : null}
              onClick={() => handleSelectContactForUpdate(contact)}
            />
          ))}
      </Collapse>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            variant="filled"
            fullWidth
            required
            value={firstName}
            label="First Name"
            onChange={(event) =>
              handleFormChange("firstName", event.target.value)
            }
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            variant="filled"
            fullWidth
            label="Last Name"
            required
            value={lastName}
            onChange={(event) =>
              handleFormChange("lastName", event.target.value)
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="filled"
            fullWidth
            label="Role"
            value={role}
            onChange={(event) => handleFormChange("role", event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="filled"
            fullWidth
            label="Email"
            value={email}
            error={emailTouched && !validator.isEmail(email)}
            onChange={(event) => handleFormChange("email", event.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="filled"
            fullWidth
            label="Mobile"
            value={mobile}
            onChange={(event) => handleFormChange("mobile", event.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={primary}
                disabled={
                  contacts && contacts.length && !updateContact
                    ? isPrimaryExist(contacts)
                    : false
                }
                onChange={(event) =>
                  handleFormChange("primary", event.target.checked)
                }
                name="Primary"
                color="primary"
              />
            }
            label="Mark as Primary"
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={handleCreateContact}
            color="primary"
            disabled={!formValidation()}
            endIcon={updateContact ? <DoneRoundedIcon /> : <AddRoundedIcon />}
          >
            {updateContact ? "Update" : "Add"}
          </Button>
          <Button
            onClick={handleCancel}
            color="primary"
            style={{ marginLeft: 4 }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AddUpdateContacts;
